import type { FC } from "react";

import { AdditionalBenefits as UIAdditionalBenefits } from "@jti/loyalty/components/AdditionalBenefits";

import type { additionalBenefitsInputs } from "./AdditionalBenefits.builder";

type AdditionalBenefitsBuilderProps = BuilderComponentProps<typeof additionalBenefitsInputs>;

export const AdditionalBenefits: FC<AdditionalBenefitsBuilderProps> = ({ title, details, benefitsList = [] }) => {
  return <UIAdditionalBenefits title={title} details={details} benefitsList={benefitsList} />;
};
